module.exports = __webpack_public_path__ + "img/demon.350329d2.png";